module.exports = __webpack_public_path__ + "img/hopways-03.50da7d9e.webp";